// Captures the browser's `beforeinstallprompt` event at module load time so it
// is never missed regardless of which page/component happens to be mounted
// when Chrome fires it, and regardless of client-side route changes.

let deferredPrompt = null;
const listeners = new Set();

const notify = () => {
	listeners.forEach((callback) => callback(deferredPrompt));
};

window.addEventListener('beforeinstallprompt', (e) => {
	e.preventDefault();
	deferredPrompt = e;
	notify();
});

window.addEventListener('appinstalled', () => {
	deferredPrompt = null;
	notify();
});

export const getDeferredInstallPrompt = () => deferredPrompt;

export const clearDeferredInstallPrompt = () => {
	deferredPrompt = null;
	notify();
};

export const subscribeToInstallPrompt = (callback) => {
	listeners.add(callback);
	return () => listeners.delete(callback);
};
